import { enumMessages } from '@/utils/MessageUtils';
import { PotentialStatus } from '@/model/sale';
import { MaterialType, MaterialCreatorType, MaterialContentType, GroupMessageStatus } from './interface';

export const tableColumns = [{
  name: 'materialId',
  title: '素材ID',
}, {
  name: 'materialTitle',
  title: '素材名称',
}, {
  name: 'materialType',
  title: '分类',
}, {
  name: 'sendSuggestion',
  title: '发送建议',
  maxWidth: 220,
}, {
  name: 'materialDetails',
  title: '素材内容',
}, {
  name: 'creatorType',
  title: '创建方',
}, {
  name: 'lastModTime',
  title: '更新时间',
}, {
  name: 'quoteTimes',
  title: '销售引用次数',
}];

export const materialTypeConfig = [
  // { value: MaterialType.sales, label: '大促活动' },
  { value: MaterialType.neighbor, label: '附近推' },
  { value: MaterialType.normalFollow, label: '常规广告' },
  { value: MaterialType.product, label: '产品功能' },
  { value: MaterialType.finance, label: '广告链路' },
  { value: MaterialType.adCreate, label: '广告开户' },
  { value: MaterialType.adPut, label: '广告投放' },
  { value: MaterialType.saleActivity, label: '促销活动' },
  { value: MaterialType.adCase, label: '广告案例' },
  { value: MaterialType.industrySolutions, label: '行业解决方案' },
  { value: MaterialType.customerRelationShip, label: '客情关系' },
  { value: MaterialType.batch, label: '群发素材' },
];

export const materialCreatorTypeConfig = [
  { value: MaterialCreatorType.official, label: '腾讯官方' },
  { value: MaterialCreatorType.corp, label: '公司素材' },
];

export const detailFormConfig = [{
  id: 'basic-info',
  title: '基础信息',
  controls: [{
    name: 'materialTitle',
    label: '素材名称',
    type: 'input',
    required: true,
    config: {
      placeholder: '请输入素材名称',
    },
  }, {
    name: 'visibleAgency',
    label: '服务商配置',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      placeholder: '请选择服务商配置',
    },
  }, {
    name: 'materialType',
    label: '分类',
    type: 'select',
    required: true,
    config: {
      data: materialTypeConfig,
      placeholder: '请选择分类',
    },
  }, {
    name: 'sendSuggestion',
    label: '发送建议',
    type: 'custom',
  }],
}, {
  id: 'material-content',
  title: '素材内容',
  controls: [{
    name: 'textMessage',
    label: '文案',
    type: 'textarea',
    config: {
      placeholder: '请输入文案',
    },
  }, {
    name: 'fileItems',
    label: '多媒体内容',
    type: 'custom',
  }],
}, {
  id: 'reference-info',
  title: '引用数据',
  controls: [{
    name: 'quoteTimes',
    label: '销售数据',
    type: 'custom',
    editable: false,
    hideLabel: true,
  }],
}];

export const sendSuggestionConfig = [{
  name: 'systemSourceTypes',
  label: '线索来源',
  type: 'select-tree',
  storeKey: 'sourceType',
  config: {
    multiple: true,
    clear: true,
  },
}, {
  name: 'sourceTypeTags',
  label: '线索标签',
  type: 'select-tree',
  storeKey: 'sourceTypeTag',
  config: {
    multiple: true,
    clear: true,
  },
}, {
  name: 'intentions',
  label: '推广目标',
  type: 'select-tree',
  storeKey: 'promotedObject',
  config: {
    multiple: true,
    clear: true,
  },
}, {
  name: 'industryIds',
  label: '行业',
  type: 'select-tree',
  storeKey: 'industry',
  config: {
    multiple: true,
    clear: true,
    search: true,
  },
}, {
  name: 'areaIds',
  label: '地域',
  type: 'select-tree',
  storeKey: 'area',
  config: {
    multiple: true,
    clear: true,
  },
}, {
  name: 'progressStatuses',
  label: '阶段',
  type: 'select',
  config: {
    multiple: true,
    clear: true,
    data: enumMessages('ProgressStatus').map(({ value, message }) => ({ value, label: message })) || [],
  },
}, {
  name: 'combineStatuses',
  label: '状态',
  type: 'select',
  config: {
    multiple: true,
    clear: true,
    data: [
      ...enumMessages('CleaningStatus').map(({ value, message }) => ({ value, label: message })) || [],
      ...enumMessages('MixedPotentialStatus').filter(({ value }) => !value.endsWith('100'))
        .map(({ value, message }) => {
          const [potentialStatus, transactionProbability] = value.split('-');
          return {
            value: potentialStatus === PotentialStatus.new ? potentialStatus : Number(transactionProbability),
            label: message };
        }) || [],
      ...enumMessages('OrderStatus').map(({ value, message }) => ({ value, label: message })) || [],
    ],
  },
}];

export const materialContentConfig = {
  [MaterialContentType.image]: {
    type: 'image',
    icon: 'icon-image',
    accept: 'image/*',
  },
  [MaterialContentType.video]: {
    type: 'video',
    icon: 'icon-video',
    accept: 'video/*',
  },
  [MaterialContentType.file]: {
    type: 'file',
    icon: 'icon-file',
  },
  [MaterialContentType.url]: {
    type: 'link',
    icon: 'icon-link',
  },
};

export const promotedObjectTextMap = {
  AD_PLATFORM_TYPE_GDT: '广点通',
  AD_PLATFORM_TYPE_MP: '微信',
  AD_PLATFORM_TYPE_NEIGHBORHOOD: '附近推',
};

export const groupMessageStatusTextMa = {
  [GroupMessageStatus.sending]: '发送中',
  [GroupMessageStatus.alreadySend]: '已发送',
};
